<template>
	<div class="require nybg">
		<div class="active">
			<div class="bgtu animated fadeIn s04"><img src="@/assets/images/nybg.png"></div>
		</div>
		<div class="active">
			<div class="nycon">
				<div class="logo animated fadeInDown s06"><img src="@/assets/images/logo.png"></div>
				<div class="nybt animated fadeInLeft s06"><img src="@/assets/images/bt6.png"></div>
				<div class="start wrap job_item animated fadeInUp s06">
					<div class="item3">岗位类别：<span>专业技术岗位</span></div>
					<div class="item3">岗位名称：<span>专任教师</span></div>
					<div class="item3">学&#12288;&#12288;历：<span>研究生</span></div>
					<div class="item3">学&#12288;&#12288;位：<span>博士</span></div>
					<div class="item3 wid">年龄要求：<p>
						应届博士毕业生要求年龄不超过35周岁（1987年1月1日及以后出生）<br />
						博士后要求年龄不超过38周岁（1984年1月1日及以后出生）<br />
						具有副高级职称要求1982年1月1日及以后出生<br />
						具有正高级职称要求1977年1月1日及以后出生
					</p>
					</div>
					<div class="item3">工作地点：<span>宜宾</span></div>
				</div>
				<div class="job_con">
					<div class="job_card animated fadeInUp s06">
						<div class="top_bt">
							<span>信息与计算科学专业教师</span><br /><span class="num">（招聘3人）</span>
							<a class="baoming"><span class="mianshi" @click="apply()">面试报名</span></a>
						</div>
						<div class="wzdetail">
							<div class="wz1">学科专业条件要求：</div>
							<div class="wz2">
								（0701）数学及其所属二级学科专业<br/>
								（0714）统计学及其所属二级学科专业<br/>
								（0810）信息与通信工程及其所属二级学科专业<br/>
								（0811）控制科学与工程及其所属二级学科专业<br/>
								（0812）计算机科学与技术及其所属二级学科专业
							</div>
						</div>
					</div>
					<div class="job_card animated fadeInUp s06">
						<div class="top_bt">
							<span>环境科学与工程专业教师</span><br /><span class="num">（招聘3人）</span>
							<a class="baoming"><span class="mianshi" @click="apply()">面试报名</span></a>
						</div>
						<div class="wzdetail">
							<div class="wz1">学科专业条件要求：</div>
							<div class="wz2">
								（0710）生物学及其所属二级学科专业<br/>
								（0830）环境科学与工程及其所属二级学科专业<br/>
								（0703）化学及其所属二级学科专业<br/>
								（0817）化学工程及其所属二级学科专业<br/>
								（0805）材料科学与工程及其所属二级学科专业
							</div>
						</div>
					</div>
					
					<div class="job_card animated fadeInUp s06">
						<div class="top_bt">
							<span>新能源材料与器件专业教师</span><br /><span class="num">（招聘4人）</span>
							<a class="baoming"><span class="mianshi" @click="apply()">面试报名</span></a>
						</div>
						<div class="wzdetail">
							<div class="wz1">学科专业条件要求：</div>
							<div class="wz2">
								（0805）材料科学与工程及其所属二级学科专业<br/>
								（0817）化学工程与技术及其所属二级学科专业<br/>
								（0703）化学及其所属二级学科专业
							</div>
							<!-- <div class="beizhu">备 注：<span>物流与供应链相关领域优先；</span></div> -->
						</div>
					</div>
					<div class="job_card animated fadeInUp s06">
						<div class="top_bt">
							<span>智能科学与技术专业教师</span><br /><span class="num">（招聘5人）</span>
							<a class="baoming"><span class="mianshi" @click="apply()">面试报名</span></a>
						</div>
						<div class="wzdetail">
							<div class="wz1">学科专业条件要求：</div>
							<div class="wz2">
								（0701）数学及其所属二级学科专业<br/>
								（0714）统计学及其所属二级学科专业<br/>
								（0804）仪器科学与技术及其所属二级学科专业<br/>
								（0810）信息与通信工程及其所属二级学科专业<br/>
								（0811）控制科学与工程及其所属二级学科专业<br/>
								（0812）计算机科学与技术及其所属二级学科专业<br/>
								（0826）兵器科学与技术及其所属二级学科专业<br/>
								（0835）软件工程及其所属二级学科专业<br/>
								（0839）网络空间安全及其所属二级学科专业
							</div>
							<!-- <div class="beizhu">备 注：<span>物流与供应链相关领域优先；</span></div> -->
						</div>
					</div>
					<div class="job_card animated fadeInUp s06">
						<div class="top_bt">
							<span>物联网工程专业教师</span><br /><span class="num">（招聘3人）</span>
							<a class="baoming"><span class="mianshi" @click="apply()">面试报名</span></a>
						</div>
						<div class="wzdetail">
							<div class="wz1">学科专业条件要求：</div>
							<div class="wz2">
								（0701）数学及其所属二级学科专业<br/>
								（0714）统计学及其所属二级学科专业<br/>
								（0804）仪器科学与技术及其所属二级学科专业<br/>
								（0810）信息与通信工程及其所属二级学科专业<br/>
								（0811）控制科学与工程及其所属二级学科专业<br/>
								（0812）计算机科学与技术及其所属二级学科专业<br/>
								（0826）兵器科学与技术及其所属二级学科专业<br/>
								（0835）软件工程及其所属二级学科专业<br/>
								（0839）网络空间安全及其所属二级学科专业
							</div>
							<!-- <div class="beizhu">备 注：<span>物流与供应链相关领域优先；</span></div> -->
						</div>
					</div>
					<div class="job_card animated fadeInUp s06">
						<div class="top_bt">
							<span>数字媒体技术专业教师</span><br /><span class="num">（招聘2人）</span>
							<a class="baoming"><span class="mianshi" @click="apply()">面试报名</span></a>
						</div>
						<div class="wzdetail">
							<div class="wz1">学科专业条件要求：</div>
							<div class="wz2">
								（0812）计算机科学与技术及其所属二级学科专业<br/>
								（0835）软件工程及其所属二级学科专业
							</div>
							<!-- <div class="beizhu">备 注：<span>物流与供应链相关领域优先；</span></div> -->
						</div>
					</div>
					<div class="job_card animated fadeInUp s06">
						<div class="top_bt">
							<span>电子信息工程专业教师</span><br /><span class="num">（招聘7人）</span>
							<a class="baoming"><span class="mianshi" @click="apply()">面试报名</span></a>
						</div>
						<div class="wzdetail">
							<div class="wz1">学科专业条件要求：</div>
							<div class="wz2">
								（0810）信息与通信工程及其所属二级学科专业<br/>
								（0809）电子科学与技术及其所属二级学科专业<br/>
								（0804）仪器科学与技术及其所属二级学科专业<br/>
								（0808）电气工程及其所属二级学科专业<br/>
								（0803）光学工程<br/>
								（0702）物理学及其所属二级学科专业
							</div>
							<!-- <div class="beizhu">备 注：<span>物流与供应链相关领域优先；</span></div> -->
						</div>
					</div>
					<div class="job_card animated fadeInUp s06">
						<div class="top_bt">
							<span>财务管理专业教师</span><br /><span class="num">（招聘2人）</span>
							<a class="baoming"><span class="mianshi" @click="apply()">面试报名</span></a>
						</div>
						<div class="wzdetail">
							<div class="wz1">学科专业条件要求：</div>
							<div class="wz2">
								（1202）工商管理及其所属二级学科专业<br/>
								（0202）应用经济学及其所属二级学科专业
							</div>
						</div>
					</div>
					<div class="job_card animated fadeInUp s06">
						<div class="top_bt">
							<span>人力资源管理专业教师</span><br /><span class="num">（招聘3人）</span>
							<a class="baoming"><span class="mianshi" @click="apply()">面试报名</span></a>
						</div>
						<div class="wzdetail">
							<div class="wz1">学科专业条件要求：</div>
							<div class="wz2">
								（1202）工商管理及其所属二级学科专业<br/>
								（1201）管理科学与工程<br/>
								（0202）应用经济学及其所属二级学科专业
							</div>
						</div>
					</div>
					<div class="job_card animated fadeInUp s06">
						<div class="top_bt">
							<span>物流管理专业教师</span><br /><span class="num">（招聘3人）</span>
							<a class="baoming"><span class="mianshi" @click="apply()">面试报名</span></a>
						</div>
						<div class="wzdetail">
							<div class="wz1">学科专业条件要求：</div>
							<div class="wz2">
								（1202）工商管理及其所属二级学科专业<br/> 
								（1201）管理科学与工程<br/>
								（0202）应用经济学及所属二级学科<br/>
								（0823）交通运输工程及所属二级学科专业
							</div>
						</div>
					</div>
					<div class="job_card animated fadeInUp s06">
						<div class="top_bt">
							<span>工程管理专业教师</span><br /><span class="num">（招聘5人）</span>
							<a class="baoming"><span class="mianshi" @click="apply()">面试报名</span></a>
						</div>
						<div class="wzdetail">
							<div class="wz1">学科专业条件要求：</div>
							<div class="wz2">
								（1201）管理科学与工程<br/>
								（1202）工商管理及其所属二级学科专业<br/>
								（1204）公共管理及其所属二级学科专业<br/>
								（0814）土木工程及其所属二级学科专业<br/>
								（0801）力学及其所属二级学科专业
							</div>
						</div>
					</div>
					<div class="job_card animated fadeInUp s06">
						<div class="top_bt">
							<span>油气储运工程专业教师</span><br /><span class="num">（招聘6人）</span>
							<a class="baoming"><span class="mianshi" @click="apply()">面试报名</span></a>
						</div>
						<div class="wzdetail">
							<div class="wz1">学科专业条件要求：</div>
							<div class="wz2">
							（0807）动力工程及工程热物理及其所属二级学科专业<br/>
							（081404）供热、供燃气、通风及空调工程<br/>
							（0820）石油与天然气工程及其所属二级学科专业
							</div>
						</div>
					</div>
					
					<!-- 12月 -->
					
					<div class="job_card animated fadeInUp s06">
						<div class="top_bt">
							<span>新能源科学与工程专业教师</span><br /><span class="num">（招聘4人）</span>
							<a class="baoming"><span class="mianshi" @click="apply()">面试报名</span></a>
						</div>
						<div class="wzdetail">
							<div class="wz1">学科专业条件要求：</div>
							<div class="wz2">
							（0709）地质学及其所属二级学科专业<br/>
							（0807）动力工程及工程热物理及其所属二级学科专业<br/>
							（0818）地质资源与地质工程及其所属二级学科专业<br/>
							（0820）石油与天然气工程及其所属二级学科专业<br/>
							（0805）材料科学与工程及其所属二级学科专业<br/>
							（0819）矿业工程及其所属二级学科专业
							</div>
						</div>
					</div>
					
					<div class="job_card animated fadeInUp s06">
						<div class="top_bt">
							<span>商务英语专业教师</span><br /><span class="num">（招聘3人）</span>
							<a class="baoming"><span class="mianshi" @click="apply()">面试报名</span></a>
						</div>
						<div class="wzdetail">
							<div class="wz1">学科专业条件要求：</div>
							<div class="wz2">
							（050201）英语语言文学<br/>
							（050211）外国语言学及应用语言学<br/>
							（0201）理论经济学及其所属二级学科专业<br/>
							（0202）应用经济学及其所属二级学科专业<br/>
							（1202）工商管理及其所属二级学科专业
							</div>
						</div>
					</div>
					
					
				</div>
				<div class="foot nyfoot col center middle animated fadeInUp s16">
					<div class="botwz">成都理工大学</div>
					<div class="botwz">360eol.com出品</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import {
		shareFun
	} from "@/utils/share.js"

	export default {
		name: "Require",
		mixins: [shareFun],
		data() {
			return {
				shareData: {
					shareLink: "",
					shareTitle: "成都理工大学宜宾校区事业编制教师考核招聘",
					shareDescription: "成都理工大学宜宾校区事业编制教师考核招聘报名条件",
					shareImage: "https://image.360eol.com/school_logo_cdut_20211209.jpg"
				},
			}
		},
		methods:{
			apply(){
				this.$router.push({
					path:"/apply",
				})
			}
		}
	}
</script>

<style lang="scss">
	@import url("../../assets/css/page.css");
</style>
